import React from "react"
import { Container, Row, Col, Table, Spinner, Button, Dropdown } from "react-bootstrap"
import { Subscription } from "rxjs"
import { toast } from "react-toastify"
import { AppState, CurrentUserPermissions } from "../../../AppState"
import { connect } from "react-redux"
import { BuildUserAccess } from "../../../authentication/BuildUserAccess"
import UserAccessSettings from "../../../authentication/UserAccessSettings"
import EmployeeToMerge from "../../../api/OrderResults/OrderResultModel/EmployeeToMerge"
import SearchField from '../../../api/SearchField'
import SearchBar from '../../SearchBar'
import FormatError from "../../../formatters/FormatError"
import SearchEmployeesToMerge from "../../../api/OrderResults/SearchEmployesToMerge"
import EmployeeToMergeInfo from "./EmployeeToMergeInfo"

const DefaultSearchFields: SearchField[] = [
  //{ ID: "All Personnel IDs", Name: "All Personnel IDs" },
  { ID: "First Name", Name: "First Name" },
  { ID: "Last Name", Name: "Last Name" },
  { ID: "Donor ID", Name: "Donor ID" }
]
interface EmployesToMergeProps {
  PersonID: number
  CompanyID: number
  isGov: boolean
  //onPoolUpdate: () => void
}


interface EmployesToMergeGridState {
  loading: boolean
  data: EmployeeToMerge[]
  mergePersonID: number
  showEmployeeToMergeInfo: boolean
}


export class EmployesToMergeGrid extends React.PureComponent<EmployesToMergeProps, EmployesToMergeGridState> {
  state: EmployesToMergeGridState = {
    loading: false,
    data: [],
    mergePersonID: 0,

    showEmployeeToMergeInfo: false
  }
  pageSubscription?: Subscription



  componentWillUnmount() {
    this.pageSubscription && this.pageSubscription.unsubscribe()
  }


  onSearch = (field: string, text: string) => {
    this.setState({ loading: true })
    this.pageSubscription && this.pageSubscription.unsubscribe()
    this.pageSubscription = SearchEmployeesToMerge(this.props.PersonID, 0, this.props.CompanyID, field, text).subscribe(
      (data: EmployeeToMerge[]) => this.setState({ data: data }),
      (error) => {
        this.setState({ loading: false })
        toast.error(FormatError(error))
      },
      () => this.setState({ loading: false })
    )
  }

  showEmployeeToMerge = (details: EmployeeToMerge) => {
    this.setState({ showEmployeeToMergeInfo: true, mergePersonID: details.PersonID })
  }
  hideEmployeeToMerge = () => {
    this.setState({ showEmployeeToMergeInfo: false, mergePersonID: 0 })
  }

  renderRows = () => {
    if (this.state.data && this.state.data.length) {
      return this.state.data.map((row: EmployeeToMerge, i: number) =>
        <tr key={i}>
          <td><Button variant="link" onClick={() => this.showEmployeeToMerge(row)} className="p-0">{row.PersonID}</Button></td>
          <td>{row.PrimaryIDType}</td>
          <td>{row.LastName}</td>
          <td>{row.FirstName}</td>
        </tr>)
    } else {
      return <tr><td colSpan={4}>No Records Found</td></tr>
    }
  }

  render() {
    const { showEmployeeToMergeInfo, mergePersonID } = this.state
    return (
      <>
        {
          showEmployeeToMergeInfo && mergePersonID > 0 &&
          <EmployeeToMergeInfo
            MergePersonID={mergePersonID}
            OriginalPersonID={this.props.PersonID} isGov={this.props.isGov}
            onHide={this.hideEmployeeToMerge}>

          </EmployeeToMergeInfo>
        }
        <Container fluid className="grid-container">
          <Row className="pb-2">
            <Col>
              <SearchBar
                allowBlank={false}
                resetButton={true}
                onSearch={this.onSearch}
                searchFields={DefaultSearchFields}
                //defaultField={DefaultSearchFields[0]}
                loading={this.state.loading}
              />
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>ID Type</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.loading ?
                      <tr>
                        <td className="text-center" colSpan={4}>
                          <Spinner animation="border" variant="secondary" />
                        </td>
                      </tr> : this.renderRows()
                  }
                </tbody>
              </Table>

            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

function mapStateToProps(state: AppState): { userPermissions: UserAccessSettings } {
  const userAccess = BuildUserAccess(state);
  return {
    userPermissions: userAccess
  }
}
const ConnectedEmployesToMergeGrid = connect(mapStateToProps, null)(EmployesToMergeGrid)
export default ConnectedEmployesToMergeGrid
